import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContractDTO  {
    _originalTypeClassName = "zERP.BO.EmployeeContractDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContractDTO.translate = translateService;
}
this.StartDate = null;
this.Salary = null;
this.DepPosTitle = null;
this.Supervisor = null;
this.DepartmentName = null;
this.EmployeeContractDTOKey = null;
this._key = this.EmployeeContractDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
StartDate:any;
Salary:any;
DepPosTitle:any;
Supervisor:any;
DepartmentName:any;
private _EmployeeContractDTOKey:any;
get EmployeeContractDTOKey(): any {
    return this._EmployeeContractDTOKey;
  }
set EmployeeContractDTOKey(value: any) {
    this._EmployeeContractDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeContractDTOKey == null || $this.EmployeeContractDTOKey == 0;
            }


}